import { render, staticRenderFns } from "./CecUnmFunctionalSpaceList.vue?vue&type=template&id=1964ad53&scoped=true"
import script from "./CecUnmFunctionalSpaceList.vue?vue&type=script&lang=js"
export * from "./CecUnmFunctionalSpaceList.vue?vue&type=script&lang=js"
import style0 from "./CecUnmFunctionalSpaceList.vue?vue&type=style&index=0&id=1964ad53&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964ad53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1964ad53')) {
      api.createRecord('1964ad53', component.options)
    } else {
      api.reload('1964ad53', component.options)
    }
    module.hot.accept("./CecUnmFunctionalSpaceList.vue?vue&type=template&id=1964ad53&scoped=true", function () {
      api.rerender('1964ad53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/unmspace/CecUnmFunctionalSpaceList.vue"
export default component.exports